import { Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { DialogHeaderBand } from "@/components/dialogs/DialogHeaderBand";
import { KINDS } from "@/components/dialogs/kinds";

/**
 * Asks before something that is hard to undo. Destructive actions (kind="danger") get a red button; everything else
 * gets the normal one. Escape and the Cancel button both mean "no". `loading` keeps it open and blocks double clicks.
 */
export function ConfirmDialog({ open, onOpenChange, kind = "warning", title, description, children, confirmLabel = "Confirm", cancelLabel = "Cancel", onConfirm, loading = false }) {
  const k = KINDS[kind] || KINDS.warning;
  return (
    <AlertDialog open={open} onOpenChange={(next) => { if (!loading) onOpenChange?.(next); }}>
      <AlertDialogContent className="max-w-md gap-0 overflow-hidden p-0" data-testid="confirm-dialog">
        <DialogHeaderBand kind={kind}>
          <AlertDialogTitle className="text-base">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription className="whitespace-pre-line text-sm">{description}</AlertDialogDescription>}
        </DialogHeaderBand>
        {children && <div className="px-6 pt-4 text-sm">{children}</div>}
        <div className="flex flex-col-reverse gap-2 px-6 py-4 sm:flex-row sm:justify-end">
          <Button type="button" variant="outline" disabled={loading} onClick={() => onOpenChange?.(false)} data-testid="confirm-dialog-cancel">{cancelLabel}</Button>
          <Button type="button" variant={k.button} disabled={loading} onClick={onConfirm} data-testid="confirm-dialog-confirm">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} {confirmLabel}
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
